module.exports = __webpack_public_path__ + "img/Group 93.28e76831.png";